export interface Theme {
  primaryColor: string;
  primaryLightColor: string;
  primaryDarkColor: string;
  backgroundColor: string;
}

export const defaultTheme: Theme = {
  primaryColor: '#BA8CFF',
  primaryDarkColor: '#BA8CFF',
  primaryLightColor: '#E9DAFF',
  backgroundColor: '#FFFFFF'
};
